import InteractionsList from '../../interactions/InteractionsList';

const ProfileResumeSection = ({
  score,
  currentUser,
  logout,
  losesAccess,
  message,
  className = '',
}) => {
  return (
    <InteractionsList
      score={score}
      message={message}
      mode="resume"
      userFilter={currentUser ?? null}
      logout={logout}
      losesAccess={losesAccess}
      className={className}
    />
  );
};

export default ProfileResumeSection;
